import React, {useEffect, useState} from 'react';
import {Alert, Button, Card, CardContent, Drawer, Stack, SvgIcon, Typography, useMediaQuery} from "@mui/material";
import localStrings from "../../localStrings";
import useAuth from "../../hooks/useAuth";
import PageWithTitle from "../../components/pages/pageWithTitle";
import {Link as RouterLink, useParams} from "react-router-dom";
import {dashboardBaseRoute, dashboardListRoute,} from "../../routes/dashboard";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ChartSelector from "../../components/chart/chartSelector";
import enqueueSnackbarWithSound from "../../utils/SnackBarWithSound";
import {addChartToBoard, addDataGridToBoard, filterBoards, removeChartBoardItem, updateChartBoardsItem} from "../Home";
import BoardAddAppBar from "../../components/Board/BoardAddAppBar";
import {executeQueryUtil} from "../../utils/gqlUtil";
import {getChartBoardsItemsQuery} from "../../gql/chartBoardItemGql";
import GridLayoutForGraph from "../../components/GridLayoutForGraph";
import {getDashBoardQuery} from "../../gql/dashBoardGql";

const CustomBoard = () => {
    const {userInDb} = useAuth()
    let {boardId} = useParams();

    const searchParams = new URLSearchParams(window.location.search);

    const[addGraphOpened, setAddGraphOpened] = useState(false);
    const[chartBoardsItems, setChartBoardsItems] = useState([]);
    const[reorganizeActive, setReorganizeActive] = useState(false);
    const[board, setBoard] = useState(false);

    const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));

    useEffect(() => {

        if (!userInDb || !boardId) {
            return;
        }
        const loadData = async () => {
            const res = await executeQueryUtil(getChartBoardsItemsQuery(userInDb.id));
            setChartBoardsItems(filterBoards(res.data?.getChartChartBoardItems, boardId));

            const resBoard = await executeQueryUtil(getDashBoardQuery(userInDb.id, boardId));
            setBoard(resBoard.data?.getDashBoard);

        }
        loadData();
    }, [userInDb, boardId]);

    function getMainButtons() {
        if (!lgUp) {
            return null;
        }

        return (
            <>
                <RouterLink to={'/' + dashboardBaseRoute + '/' + dashboardListRoute}
                            style={{ textDecoration: 'none' }}
                >
                    <Button
                        color="primary"
                        variant="contained"
                    >
                        {localStrings.manageMyBoards}
                    </Button>
                </RouterLink>
            </>
        )
    }

    return (
        <PageWithTitle title={board?.name}
                       mainButtons={getMainButtons()}
        >
            <BoardAddAppBar
                reorganizeActive={reorganizeActive}
                setReorganizeActive={setReorganizeActive}
                setAddGraphOpened={setAddGraphOpened}
                chartBoardsItems={chartBoardsItems}
            />

            <Drawer
                PaperProps={{
                    sx: {width: lgUp ? "70%" : "95%"},
                }}
                anchor="right"
                open={addGraphOpened}
                onClose={() => setAddGraphOpened(false)}
            >
                <ChartSelector
                    addChartToBoardCallBack={(item) => addChartToBoard(item, setAddGraphOpened, userInDb,
                        enqueueSnackbarWithSound, chartBoardsItems, setChartBoardsItems, boardId)}

                    addDataGridToBoardCallBack={(item) => addDataGridToBoard(item, setAddGraphOpened, userInDb,
                        enqueueSnackbarWithSound, chartBoardsItems, setChartBoardsItems, boardId)}

                    closeCallBack={() => setAddGraphOpened(false)}
                />
            </Drawer>

            <Card

                sx={{width: '100%'}}>
                <CardContent sx={{padding: lgUp ? 'inherits' : '0px'}}>
                    <GridLayoutForGraph
                        updateItemCallBack={async (item) =>
                            await updateChartBoardsItem(item , userInDb, chartBoardsItems, setChartBoardsItems)
                        }
                        reorganizeActive={reorganizeActive}
                        chartBoardsItems={chartBoardsItems}
                        removeChartBoardItemCallBack={async (item) =>
                            await removeChartBoardItem(item, userInDb, chartBoardsItems, setChartBoardsItems)
                        }
                    />
                </CardContent>

                {chartBoardsItems && chartBoardsItems.length === 0 &&
                <Stack sx={{width: '100%', marginTop: 5}} spacing={2}>
                    <Alert severity="warning">
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            {localStrings.noDashBoradYet}
                        </Typography>

                    </Alert>
                </Stack>
                }
            </Card>
        </PageWithTitle>
    );
};

export default CustomBoard;
